// ChatModals.js - Optimized modal components
import React, { memo } from 'react';

// Settings Modal Component
export const SettingsModal = memo(({ 
  showSettings, 
  onClose, 
  usernameColor, 
  onColorChange 
}) => {
  if (!showSettings) return null;

  return (
    <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgba(31, 41, 55, 0.4)',
      padding: '1.5rem',
      borderRadius: '8px',
      border: '1px solid rgba(75, 85, 99, 0.3)',
      width: '90%',
      maxWidth: '300px',
      zIndex: 1000,
      backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem'
      }}>
        <h3 style={{ color: '#ffffff', margin: 0 }}>Chat Settings</h3>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: '#ffffff',
            cursor: 'pointer',
            padding: '4px'
          }}
        >✕</button>
      </div>
      
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ 
          display: 'block', 
          color: '#ffffff', 
          marginBottom: '0.5rem' 
        }}>
          Username Color
        </label>
        <input
          type="color"
          value={usernameColor}
          onChange={(e) => onColorChange(e.target.value)}
          style={{
            width: '100%',
            height: '40px',
            padding: '0',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        />
      </div>
    </div>
  );
});

// Moderate Modal Component
export const ModerateModal = memo(({ 
  showModerateModal, 
  onClose, 
  bannedUsers, 
  onUnban 
}) => {
  if (!showModerateModal) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'rgba(31, 41, 55, 0.95)',
        padding: '1.5rem',
        borderRadius: '8px',
        border: '1px solid rgba(75, 85, 99, 0.3)',
        width: '90%',
        maxWidth: '300px',
        backdropFilter: 'blur(4px)'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1rem'
        }}>
          <h3 style={{ color: '#ffffff', margin: 0 }}>Moderate Chat</h3>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#ffffff',
              cursor: 'pointer',
              padding: '4px'
            }}
          >✕</button>
        </div>
        
        <h4 style={{ color: '#ffffff', marginBottom: '0.5rem' }}>Banned Users</h4>
        <div style={{
          maxHeight: '200px',
          overflowY: 'auto'
        }}>
          {bannedUsers.length === 0 ? (
            <p style={{ color: '#9ca3af' }}>No banned users</p>
          ) : (
            bannedUsers.map(user => (
              <div key={user.memberstackId} style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.5rem',
                borderBottom: '1px solid rgba(75, 85, 99, 0.3)'
              }}>
                <span style={{ color: '#ffffff' }}>{user.displayName}</span>
                <button
                  onClick={() => onUnban(user.memberstackId)}
                  style={{
                    padding: '0.25rem 0.5rem',
                    backgroundColor: 'rgba(239, 68, 68, 0.8)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '0.375rem',
                    cursor: 'pointer'
                  }}
                >
                  Unban
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
});

// Delete Modal Component
export const DeleteModal = memo(({ 
  showDeleteModal, 
  onClose, 
  selectedMessage, 
  onDeleteMessage, 
  onBanUser 
}) => {
  if (!showDeleteModal || !selectedMessage) return null;

  const handleDelete = () => {
    onDeleteMessage(selectedMessage.id);
    onClose();
  };

  const handleBan = () => {
    onBanUser(selectedMessage.memberstackId, selectedMessage.displayName);
    onClose();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'rgba(31, 41, 55, 0.95)',
        padding: '1.5rem',
        borderRadius: '8px',
        border: '1px solid rgba(75, 85, 99, 0.3)',
        width: '90%',
        maxWidth: '300px',
        backdropFilter: 'blur(4px)'
      }}>
        <h3 style={{ color: '#ffffff', marginTop: 0 }}>Moderation Actions</h3>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem'
        }}>
          <button
            onClick={handleDelete}
            style={{
              padding: '0.5rem',
              backgroundColor: 'rgba(239, 68, 68, 0.8)',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: 'pointer'
            }}
          >
            Delete Message
          </button>
          <button
            onClick={handleBan}
            style={{
              padding: '0.5rem',
              backgroundColor: 'rgba(175, 0, 0, 0.5)',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: 'pointer'
            }}
          >
            Ban User
          </button>
          <button
            onClick={onClose}
            style={{
              padding: '0.5rem',
              backgroundColor: 'rgba(75, 85, 99, 0.5)',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
});

SettingsModal.displayName = 'SettingsModal';
ModerateModal.displayName = 'ModerateModal';
DeleteModal.displayName = 'DeleteModal'; 